module.exports = __webpack_public_path__ + "static/media/yellow-check.59d10d23.svg";